<app-layout>
  <div class="main">
    <div class="header-table">
      <div class="title">
        <app-titulo>Janelas de Agendamento</app-titulo>
      </div>
      <div class="header-buttons">
        <app-botao
          type="primario"
          text="Nova Janela"
          icon="assets/add.svg"
          (click)="abrirModal()"></app-botao>
      </div>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">Janelas Cadastradas <br /></div>
      </div>
      <app-loader [isLoading]="isLoading"></app-loader>
      <app-tabela
        *ngIf="!isLoading"
        [data]="tableData"
        [columns]="tableColumns"></app-tabela>
    </div>
  </div>

  <div class="mobile">
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>

  <app-subtitulo *ngIf="!tableData.length && !isLoading"
    >Nenhum registro encontrado.</app-subtitulo
  >
</app-layout>

<!-- Modal for Create/Edit -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content">
    <div class="modal-header">
      <h3>{{ form.value.PK_JNLA ? 'Editar Janela' : 'Nova Janela' }}</h3>
      <button class="btn-close" (click)="fecharModal()">&times;</button>
    </div>
    <form [formGroup]="form" (ngSubmit)="salvar()">
      <div class="modal-body">
        <div class="form-group">
          <app-input
            label="Horário de Início (HH:mm)"
            name="HR_INIC"
            formControlName="HR_INIC"
            mask="00:00"
            width="100%" />
        </div>
        <div class="form-group">
          <app-input
            label="Horário de Fim (HH:mm)"
            name="HR_FIM"
            formControlName="HR_FIM"
            mask="00:00"
            width="100%" />
        </div>
        <div class="form-group checkbox">
          <input type="checkbox" formControlName="FL_STTS" id="fl_stts">
          <label for="fl_stts">Ativo</label>
        </div>
      </div>
      <div class="modal-footer">
        <app-botao type="secundario" text="Cancelar" (click)="fecharModal()"></app-botao>
        <app-botao type="primario" text="Salvar" [disabled]="form.invalid"></app-botao>
      </div>
    </form>
  </div>
</div>
